import { VAT_RATE } from "../../../subscription";

export const withVat = (base, includeVat) => (includeVat ? Math.round(base * (1 + VAT_RATE) * 100) / 100 : base);

export const uniqueFeatures = (features) => {
    const seen = new Set();
    return features.filter((feature) => {
        if (seen.has(feature)) {
            return false;
        }
        seen.add(feature);
        return true;
    });
};
